import { useFocusEffect } from "@react-navigation/native";
import React, {useState, useCallback, useEffect} from "react";
import Constants from 'expo-constants'
import { View, StyleSheet, Text, TouchableOpacity, Image, FlatList } from "react-native";
import { format} from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import colors from '../styles/colors'
import { firebaseAuth } from "../../firebase";
import { LoadOrders, loadUser } from "../services/firebaseServices";
import MyText from "../components/MyText";

const pathOrder = '/Order';
export default function Orders({navigation}){
    const[user, setUser] = useState(null)
    const [order, setOrder] = useState(null)
    useFocusEffect(
        useCallback(()=>{
            
            if(firebaseAuth.currentUser !== null && firebaseAuth.currentUser !== undefined)
            loadUser('/User', firebaseAuth.currentUser.uid, response => setUser(response))

            return ()=> {}
        },[])
    )

    useEffect(()=>{
        if(user !== null){
            LoadOrders(pathOrder,firebaseAuth.currentUser.uid, response => setOrder(response))
        }
    },[user])


    function renderItem(item){
        let cor = ''
        switch(item.status){
            case "Pendente":
                cor = colors.yellow
                break;
            case "Produção":
                cor = colors.orange
                break;
            case 'Aguardando Retirada':
                cor = colors.yellow
                break;
            case 'Saiu para Entrega':
                cor = colors.zapColor
                break;
            case 'Entregue':
                cor = colors.zapColor
                break;
            case 'Cancelado':
                cor = colors.red
                break;
        }
        return(
            <TouchableOpacity style={styles.containerItem} onPress={()=>{navigation.navigate("OrderDetail",{id: item.idOder, key: item.key})}}>
                <View style={styles.containerHorizontalItem}>
                    <MyText style={styles.txtOrder}>#{item.idOder}</MyText>
                    <MyText style={[styles.txtStatus, {backgroundColor: cor}]}>{item.status}</MyText>
                </View>
                <MyText style={styles.txtName}>{Constants.expoConfig.name}</MyText>
                <View style={styles.containerHorizontalItem}>
                    <MyText style={styles.txtPrice}>R$ {item.total.toFixed(2)}</MyText>
                    <MyText style={styles.txtDate}>{format(new Date(item.create), 'dd/MM/yyyy')} às {item.historyStatus[0].time}</MyText>
                </View>
            </TouchableOpacity>
        )
    }

    return(
        <View style={styles.container}>
             <MyText style={styles.title}>Pedidos</MyText>
             {user === null ? (
                 <>
                    
                    <Image style={styles.imgPed} source={require('../../assets/img/empty-cart.png')} resizeMode={"center"}/>
                    <MyText style={styles.txtLoged}>Para ver seus pedidos você precisa realizar login, caso não tenha uma conta ainda, crie uma conta 😁✌️</MyText>
                    <View style={styles.containerBtnUser}>
                        <TouchableOpacity style={styles.btnLog} onPress={()=>{navigation.navigate("Login")}}>
                            <MyText style={styles.txtBtn}>Login</MyText>
                        </TouchableOpacity>
                        <TouchableOpacity style={styles.btnCreate} onPress={()=>{navigation.navigate("User")}}>
                            <MyText style={styles.txtBtn}>Cadastre-se</MyText>
                        </TouchableOpacity>
                    </View>
                </>
             ):
             (<>
                {order === null ? 
                (
                    <>
                        <Image style={styles.imgPed} source={require('../../assets/img/empty-cart.png')}/>
                        <MyText style={styles.txtNullPedidos}>Não há pedidos realizados</MyText>
                    </>
                ):
                (
                    <>
                        <FlatList
                            data={order}
                            keyExtractor={item => item.key}
                            renderItem={({item}) => renderItem(item)}
                            style={{flex: 1}}
                        />
                    </>
                )}

             </>)}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1
    },
    title: {
        fontSize: 20,
        backgroundColor: "white",
        paddingHorizontal: 25,
        paddingTop: 35,
        paddingBottom: 20
    },
    imgPed: {
        width: 250,
        height: 250,
        alignSelf: 'center',
        marginTop: 100
    },
    txtLoged: {
        fontSize: 17,
        textAlign: 'center',
        alignSelf: 'center',
        marginVertical: 20
    },
    containerBtnUser: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginTop: 10
    },
    btnLog: {
        width: 150,
        height: 40,
        backgroundColor: colors.red,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 5
    },
    txtBtn: {
        fontSize: 15,
        color: 'white'
    },
    btnCreate: {
        width: 150,
        height: 40,
        backgroundColor: colors.red,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 5
    },
    txtNullPedidos: {
        color: colors.red,
        fontSize: 17,
        alignSelf: 'center',
        marginTop: 10
    },
    // item order
    containerItem: {
        padding: 10,
        backgroundColor: 'white',
        marginTop: 10,
        marginHorizontal: 10,
        borderRadius: 5
    },
    containerHorizontalItem: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    txtOrder: {
        color: colors.gray3,
        fontSize: 15
    },
    txtStatus: {
        color: 'white',
        fontSize: 12,
        paddingVertical: 4,
        paddingHorizontal: 8,
        borderRadius: 3
    },
    txtName: {
        fontSize: 18,
        marginVertical: 10,
        fontWeight: 'bold'
    },
    txtPrice: {
        fontSize: 15
    },
    txtDate: {
        fontSize: 15
    }
})